import { ComponentType as e } from "../../registries/types/propTypes.js";
const i = (o) => ({
  componentType: e.notification,
  message: o == null ? void 0 : o.message,
  _version: o == null ? void 0 : o._version,
  callBack: o == null ? void 0 : o.callBack
});
export {
  i as default
};
//# sourceMappingURL=notification-transformer.js.map
